export const polkoClientsActiveProducts = {
    "hogar": {
        "active": true,
        "codigos_aseguradoras": [
            {"id_aseguradora": 1}
        ]
    },
    "vehiculo": {
        "active": true,
        "codigos_aseguradoras": [
            {"id_aseguradora": 1},
            {"id_aseguradora": 2},
            {"id_aseguradora": 3},
            {"id_aseguradora": 7}
        ]
    },
    "microseguros": {
        "active": true,
        "codigos_aseguradoras": [
            {"id_aseguradora": 1}
        ]
    },
    "motovehiculo": {
        "active": true,
        "codigos_aseguradoras": [
            {"id_aseguradora": 1},
            {"id_aseguradora": 2},
            {"id_aseguradora": 7}
        ]
    },
    "asistencia_viajero": {
        "active": true,
        "codigos_aseguradoras": [
            {"id_aseguradora": 4}
        ]
    }
}
